// hooks/usePagination.js

import { useState, useMemo, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

export const usePagination = (items, itemsPerPage = 20) => {
  const [searchParams, setSearchParams] = useSearchParams();
  
  // Get page from URL or default to 1
  const pageFromUrl = parseInt(searchParams.get('page')) || 1;
  const [currentPage, setCurrentPage] = useState(pageFromUrl);

  // Sync currentPage with URL
  useEffect(() => {
    const urlPage = parseInt(searchParams.get('page')) || 1;
    if (urlPage !== currentPage) {
      setCurrentPage(urlPage);
    }
  }, [searchParams]);

  // Calculate pagination values
  const totalPages = Math.ceil(items.length / itemsPerPage);
  
  // Ensure current page is valid
  const validCurrentPage = Math.min(Math.max(1, currentPage), totalPages || 1);
  
  const indexOfLastItem = validCurrentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  
  // Get current items
  const currentItems = useMemo(() => {
    return items.slice(indexOfFirstItem, indexOfLastItem);
  }, [items, indexOfFirstItem, indexOfLastItem]);

  // Change page and update URL
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
    setSearchParams({ page: pageNumber.toString() });
  };

  // Reset to first page (useful when items change)
  const resetPage = () => {
    setCurrentPage(1);
    setSearchParams({ page: '1' });
  };

  return {
    currentPage: validCurrentPage,
    totalPages,
    currentItems,
    indexOfFirstItem,
    indexOfLastItem,
    handlePageChange,
    resetPage,
    totalItems: items.length,
  };
};

export default usePagination;